
import Vue from 'vue'

import CustomTextModal from './CustomTextModal.vue'
import { RButton } from '@/components/'

export default Vue.extend({
  name: 'CreateWorkstationModal',
  components: {
    CustomTextModal,
    RButton,
  },
  props: {
    limit: {
      type: Number,
      required: true,
    },
    used: {
      type: Number,
      required: true,
    },
    pending: {
      type: Boolean,
      default: false,
    },
  },
})
